import { AuthInfos } from "../models/auth-infos";

declare global {
  interface Window {
    Wized: any;
  }
}

class WizedService {
  async onLogin(infos: AuthInfos) {
    if (!window.Wized) { console.info("Wized is not defined"); return }

    if (!infos.userEmail) { console.info("userEmail is not defined"); return }
    if (!infos.userAirTableId) { console.info("userAirTableId is not defined"); return }

    window.Wized.data.setVariable("privyLibEmail", infos.userEmail)
    window.Wized.data.setVariable("userId", infos.userAirTableId)

    try {
      await window.Wized.request.execute(".getUserLoginV3")
    } catch (error) { console.log("Wized error", error) }
  }
}

export const wizedService = new WizedService()
